const content = {
    nav: {
        logo: 'Ali Chaabane',
        links: [
            // { text: 'Progetti', to: 'project' },
            { text: 'Contatto', to: 'contact' },
        ],
    },

    header: {
        text: ['Ciao!', 'Sono Ali Chaabane.', 'Sono un '],
        typical: [
            'Sviluppatore Full Stack 💻',
            2000,
            'Sviluppatore Web & Mobile 📱',
            2000,
        ],
        btnText: 'Scopri di più',
    },

    stack: {
        title: 'Tecnologie che utilizzo',
        tech: [
            { img: process.env.PUBLIC_URL + '/assets/flutter.png', alt: 'Flutter' },
            { img: process.env.PUBLIC_URL + '/assets/ionic.png', alt: 'Ionic' },
            { img: process.env.PUBLIC_URL + '/assets/angular.png', alt: 'Angular' },
            { img: process.env.PUBLIC_URL + '/assets/spring.png', alt: 'Spring Boot' },
            { img: process.env.PUBLIC_URL + '/assets/vue.png', alt: 'Vue.js' },
            { img: process.env.PUBLIC_URL + '/assets/nuxt.png', alt: 'Nuxt.js' },
            { img: process.env.PUBLIC_URL + '/assets/node.png', alt: 'Node.js' },
            { img: process.env.PUBLIC_URL + '/assets/express.png', alt: 'Express.js' },
        ],
        desc: `
Sono specializzato nello sviluppo di applicazioni web e mobile multipiattaforma.

Per le applicazioni mobile utilizzo principalmente Flutter e Ionic
per creare applicazioni performanti per Android, iOS
e Progressive Web Apps (PWA).

Per il web e il backend lavoro soprattutto con Angular e Node.js (Express),
oltre a Java Spring Boot per sviluppare servizi backend
scalabili e facilmente manutenibili.

Mi concentro su architetture pulite, prestazioni elevate
e soluzioni pronte per ambienti di produzione,
migliorando costantemente le mie competenze.
        `,
    },

    languages: {
        title: 'Lingue',
        list: [
            { name: 'Arabo', level: 'Madrelingua', percent: 100 },
            { name: 'Inglese', level: 'Avanzato', percent: 90 },
            { name: 'Francese', level: 'Avanzato', percent: 80 },
            { name: 'Italiano', level: 'Intermedio', percent: 30 },
            { name: 'Turco', level: 'Intermedio', percent: 40 },
        ],
    },

    project: {
        visible: false,
        title: 'Progetti',
        img: process.env.PUBLIC_URL + '/assets/project-mobile.png',
        imgPlaceholder: 'data:image/png;base64,...',
        projectName: 'Meetup',
        desc: 'Introduzione all’app Meetup (il mio primo progetto React)',
        website: 'https://meetups-project-86e41.web.app/',
    },

    contact: {
        title: 'Contattami',
        desc: `
Sviluppatore Full Stack con oltre 5 anni di esperienza
nello sviluppo di applicazioni web e mobile multipiattaforma.

Solida esperienza pratica con Flutter, Ionic, Angular, Node.js
e Java Spring Boot, con progetti enterprise ed e-commerce
in produzione per clienti internazionali.

Orientato a soluzioni scalabili, pulite e manutenibili,
mi adatto rapidamente agli ambienti Agile
e collaboro efficacemente all’interno dei team.
        `,
    socials: [
      {
        alt: 'whatsapp',
        img: process.env.PUBLIC_URL + '/assets/whatsapp.png',
        link: 'https://api.whatsapp.com/send/?phone=905421959236',
      },
      {
        alt: 'email',
        img: process.env.PUBLIC_URL + '/assets/gmail.png',
        link: 'mailto:alichaabane.work@gmail.com',
      },
      {
        alt: 'linkedin',
        img: process.env.PUBLIC_URL + '/assets/link.png',
        link: 'https://www.linkedin.com/in/ali-chaabane/',
      },
      {
        alt: 'github',
        img: process.env.PUBLIC_URL + '/assets/github.png',
        link: 'https://github.com/alichaabane',
      },
    ],
    img: process.env.PUBLIC_URL + '/assets/my-image.jpg',
    },
};

export default content;
